// Vite doesn't define a global field in window as webpack does,
// which is required by libs like react-image-lightbox
//
// *Important*: This file must be imported before anything else in the app.
//
// See https://stackoverflow.com/a/73208485
window.global ||= window;
